<template>
    <div class="flex items-center relative"
    >
      <template v-if="relevantTime">
        <!-- Use moment to format the true_send_time -->
        {{ formatDate(relevantTime) }}
        <template v-if="data.recurring_rule_human">
            <font-awesome-icon :icon="['fas', 'arrows-rotate']" class="text-gray-600 cursor-pointer ml-2"
                @mouseenter="showTooltip=true"
                @mouseleave="showTooltip=false"
            />
            <div class="absolute group-hover:visible bg-black text-white px-4 mb-3 py-2 text-sm rounded-md transition-opacity shadow-sm click-events-none"
                v-if="showTooltip" 
                style="top:-10px; left:calc(100% + 10px); z-index: 100; white-space: nowrap;"
            >
                <p class="leading-4 text-white">  {{ data.recurring_rule_human }}</p>
                <svg class="absolute z-10 left-0 top-3.5" style="left: -13px; transform: rotate(90deg);" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 10L0 0L16 1.41326e-06L8 10Z" fill="#3a3a3a" class="bg-black"/>
                </svg>
            </div>
        </template>
      </template>
      <template v-else-if="data.status == 'attempt_rejected'">
        failed to send
      </template>
      <template v-else>
        -
      </template>
    </div>
  </template>
  
  <script>
   import moment from 'moment';
  export default {
    name: "MessageTableSendTime",
    props: {
      meta: {
        type: Object,
        default: () => ({})
      },
      name: {
        type: String,
        default: ""
      },
      data: {
        type: Object,
        default: () => ({
            
        })
      },
    },
    data() {
      return {
        showTooltip: false,
      };
    },
    methods: {
        formatDate(date) {
            // Define an array of possible date formats
            const formats = ['MM-DD-YYYY h:mm a', 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ'];

            // Parse the date using the possible formats
            const dateObj = moment(date, formats, true); // 'true' for strict parsing

            // Format the date as MM-DD-YYYY h:mmA
            return dateObj.format('MM-DD-YYYY h:mma');
        },


    },
    computed: {
        relevantTime() {
            if (this.data.true_send_time) {
                return this.data.true_send_time;
            } else if (this.data.scheduled_send_time) {
                return this.data.scheduled_send_time;
            } else {
                return null;
            }
        },
        recurring() {
            return this.data.recurring_rule_human;
        }
    }
  };
  </script>
  
  <style scoped lang="scss">
  /* Your styles here */
  </style>
  